var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svgicon',{class:{ [_vm.$options.name]: true, 'default-size': _vm.defaultSize },attrs:{"name":_vm.name,"fill":_vm.fill,"original":_vm.original}})
}
var staticRenderFns = []

export { render, staticRenderFns }